import React from 'react';
import classes from './ErrorMessage.module.scss';

const ErrorMessage = ({ message }) => {
  return <span className={classes.errorMessage}>{message}</span>;
};

export default ErrorMessage;
